import { render, staticRenderFns } from "./segment-form.vue?vue&type=template&id=378c6352&"
import script from "./segment-form.vue?vue&type=script&lang=js&"
export * from "./segment-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports